import {
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { useOrganizationContext } from "../../../../providers/OrganizationAdmin/OrganizationProvider";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import QTDetailsImageWithLabelSection from "../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsLocationWithLabelSection from "../../../../common/QTDetailsLocationWithLabelSection";
import QTDetailsLatLongSection from "../../../../common/QTDetailsLatLongSection";

const OrgProfDataFieldsSection = ({
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
}) => {
  const { currentOrganization, setCurrentOrganization } =
    useOrganizationContext();
  console.log('Org Data: ', currentOrganization)
  // const sanitizeURL = (url) => {
  //   // Remove protocol (http, https) and www
  //   return url.replace(/^(https?:\/\/)?(www\.)?/, "");
  // };

  return (
    <>
    <Grid container style={dataContainerStyles} id="org-profile">
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Name"}
          value={currentOrganization?.name}
          disabled={true}
          editEnabled={editEnabled}
          // setDetails={currentOrganization}
          setUploadImage={setUploadImage}
          onChange={(e) =>
            setCurrentOrganization({
              ...currentOrganization,
              name: e.target.value,
            })
          }
        />

        {/*ALbum Title section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Handle"}
          // value={albumDetails.orgHandle}
          value={currentOrganization?.handle}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setCurrentOrganization({
              ...currentOrganization,
              handle: e.target.value,
            })
          }
        />
        <QTDetailsTextFieldWithLabelSection
          label={"Org Email"}
          // value={albumDetails.orgHandle}
          value={currentOrganization?.orgEmail}
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setCurrentOrganization({
              ...currentOrganization,
              email: e.target.value,
            })
          }
        />
        {/*Created By section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Link"}
          // value={albumDetails.link}
          // value={
          //   editEnabled
          //     ? currentOrganization?.link
          //     : sanitizeURL(currentOrganization?.link)
          // }
          value={currentOrganization?.link}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setCurrentOrganization({
              ...currentOrganization,
              link: e.target.value,
            })
          }
        />

        {/*location section*/}
        <QTDetailsLocationWithLabelSection
          label={"Location"}
          locationDisplayValue={currentOrganization?.locationDisplay}
          value={currentOrganization?.location || ""}
          quicktaleDetails={currentOrganization}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(docData) => {
            console.log("doc data::", docData);
            setCurrentOrganization({
              ...currentOrganization,
              coordinates: docData.coordinates,
              location: docData.location,
              locationDisplay: docData.locationDisplay,
              locationCountry: docData.locationCountry,
              g: docData.g,
            });
            // setQuicktaleDetails({ ...currentOrganization, ...docData });
          }}
        />

        {/*Geo Hash section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Geohash"}
          value={currentOrganization?.g?.geohash ?? ""}
          disabled={true}
        />
        {/*Lat/long section*/}

        <QTDetailsLatLongSection
          label={"Lat/Long"}
          // currentOrganization={currentOrganization}
          value={
            currentOrganization?.coordinates?._lat ?? "" +
            "," +
            currentOrganization?.coordinates?._long ?? ""
          }
          latValue={currentOrganization?.coordinates?._lat}
          longValue={currentOrganization?.coordinates?._long}
          onChange={(data) => {
            setCurrentOrganization({
              ...currentOrganization,
              coordinates: data.coordinates,
              location: data.location,
              g: data.g,
            });
          }}
          disabled={true}
          editEnabled={editEnabled}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*  */}
        <div>
          <QTDetailsImageWithLabelSection
            label={"Logo"}
            image={currentOrganization?.logoOP}
            fileName={currentOrganization?.originalPhotoNameOP || ""}
            handleImagePreviewModalOpen={() => handleImagePreviewModalOpen('logo')}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            details={currentOrganization}
            setDetails={setCurrentOrganization}
          />
          <Typography id="dimensions">
            <br></br>Recommended Dimensions: 940px W x 440px H with 45px of white space all around (see template)
            <br></br>Red box is the area in which to center your logo.  Remove before uploading.
            <div  style={{ display: "flex", justifyContent: "left", marginBottom: 20 }}>
              <img border="1px solid" src="/org_logos_template.png" alt="Org Logo Template" style={{ width: "30%", height: "auto", marginTop: 10 }} /> 
              <span style={{marginLeft: 10, marginTop: 45}}><a  href="/org_logos_template.png" download="qt_logo_template">Download Template</a></span>
              </div>
          </Typography>
        </div>
        {/*Description section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Description"}
          // value={albumDetails.description}
          value={currentOrganization?.description}
          disabled={true}
          multiline={true}
          rows={3}
          editEnabled={editEnabled}
          onChange={(e) =>
            setCurrentOrganization({
              ...currentOrganization,
              description: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>

    {/*Default settings section*/}
    <Grid container style={dataContainerStyles} id="org-profile-settings">
      {/*left column*/}
      <Grid item container direction={"column"} xs="auto">
      <Typography style={groupTitleStyle}>Audio Reactions</Typography>
      <Grid container style={groupRowStyle}>
        <InlineCheckbox
          label="Allow Audio Reactions"
          field="allowAR"
          currentOrganization={currentOrganization}
          setCurrentOrganization={setCurrentOrganization}
          editEnabled={editEnabled}
        />
        <InlineCheckbox
          label="Auto-Approve Audio Reactions"
          field="autoApproveAR"
          currentOrganization={currentOrganization}
          setCurrentOrganization={setCurrentOrganization}
          editEnabled={editEnabled}
        />
      </Grid>
      <Typography style={groupTitleStyle}>Batch &amp; QuickCollect</Typography>
      <Grid container style={groupRowStyle}>
        <InlineCheckbox
          label="Import Batch Auto-Approve"
          field="importBatchAutoApprove"
          currentOrganization={currentOrganization}
          setCurrentOrganization={setCurrentOrganization}
          editEnabled={editEnabled}
        />
        <InlineCheckbox
          label="QuickCollect Auto-Approve"
          field="quickCollectAutoApprove"
          currentOrganization={currentOrganization}
          setCurrentOrganization={setCurrentOrganization}
          editEnabled={editEnabled}
        />
      </Grid>
      </Grid>
      {/*right column*/}
      <Grid item container direction={"column"} xs style={{ paddingLeft: 32 }}>
      <Typography style={groupTitleStyle}>Areas</Typography>
      <Grid container style={groupRowStyle}>
        <FormControlLabel
          labelPlacement="start"
          label="Add Area Status Default"
          disabled={!editEnabled}
          control={
            <Select
              size="small"
              value={
                currentOrganization?.createAreaStatusDefault === "Inactive"
                  ? "Inactive"
                  : "Active"
              }
              disabled={!editEnabled}
              onChange={(e) =>
                setCurrentOrganization({
                  ...currentOrganization,
                  createAreaStatusDefault: e.target.value,
                })
              }
              sx={{
                marginLeft: "48px",
                minWidth: 120,
                fontSize: 14,
                fontFamily: "Avenir Book, sans-serif",
              }}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          }
          sx={{
            ...inlineControlSx,
            width: "auto",
            justifyContent: "flex-start",
            "& .MuiFormControlLabel-label": {
              ...inlineControlSx["& .MuiFormControlLabel-label"],
              whiteSpace: "nowrap",
            },
          }}
        />
      </Grid>
      </Grid>
    </Grid>
    </>
  );
};

const InlineCheckbox = ({
  label,
  field,
  currentOrganization,
  setCurrentOrganization,
  editEnabled,
}) => (
  <FormControlLabel
    labelPlacement="start"
    label={label}
    control={
      <Checkbox
        checked={currentOrganization?.[field] ?? false}
        disabled={!editEnabled}
        onChange={(e) =>
          setCurrentOrganization({
            ...currentOrganization,
            [field]: e.target.checked,
          })
        }
        sx={{
          color: "#515563",
          marginLeft: "16px",
          "&.Mui-checked": { color: "#1976d2" },
          "&.Mui-disabled": { color: "#515563" },
        }}
      />
    }
    sx={inlineControlSx}
  />
);

const inlineControlSx = {
  marginLeft: 0,
  marginRight: "48px",
  width: 300,
  justifyContent: "space-between",
  "& .MuiFormControlLabel-label": {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Avenir Book, sans-serif",
    color: "#020303",
  },
  "& .MuiFormControlLabel-label.Mui-disabled": { color: "#020303" },
};

export default OrgProfDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};

const groupTitleStyle = {
  color: "#020303",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
  marginBottom: 4,
};

const groupRowStyle = {
  paddingLeft: 30,
  marginBottom: 12,
};
